import React from 'react';

const Dashboard = React.lazy(() => import('./HomePage'));

const HomeConfig = {
  settings: {
    layout: {
      config: {},
    },
  },

  routes: [
    {
      path: 'dashboard',
      element: <Dashboard />,
    },
  ],
};

export default HomeConfig;
